import "./App.css";
import Weather from "./Weather";

function App() {
  return (
    <div className="App">
      <Weather defaultCity="São Paulo" />
    </div>
  );
}

export default App;
